export default __webpack_public_path__ + "static/media/grid2.c73b482d.jpg";